import * as ng from 'angular';

import 'angular-cookies';
import 'angular-animate';
import 'ng-file-upload';
import 'angular-ui-bootstrap';
import 'ui-select';
import 'angular-ui-tinymce';
import '@uirouter/angularjs';
import 'angular-messages';
import 'checklist-model';
import 'angular-gridster';
import 'angular-local-storage';
import 'angular-bootstrap-lightbox';
import 'angular-gettext';

const requiredModules = [
   'LocalStorageModule',
   'bootstrapLightbox',
   'checklist-model',
   'gettext',
   'gridster',
   'ngAnimate',
   'ngCookies',
   'ngFileUpload',
   'ngMessages',
   'ui.bootstrap',
   'ui.router',
   'ui.select',
   'ui.tinymce'
];

// Note: config function for LocalStorageModule, default is "ls."
configFn.$inject = ['localStorageServiceProvider'];
function configFn(localStorageServiceProvider) {
   localStorageServiceProvider
      .setPrefix('ls.')
      .setStorageType('localStorage')
      .setNotify(true, true);
};

// Performance Options
function appConfigDigest($rootScopeProvider) {
   $rootScopeProvider.digestTtl(10); //default
}

function appConfigAsync ($httpProvider) {
   $httpProvider.useApplyAsync(true) //default
}

function appConfigDebug ($compileProvider) {
   $compileProvider.debugInfoEnabled(true) //default
}

const app = ng
   .module('e360', requiredModules, configFn)
   .config(['$httpProvider', appConfigAsync])
   .config(['$compileProvider', appConfigDebug])
   .config(['$rootScopeProvider', appConfigDigest]);

export default app;

// lots of js files expect e360 global, remove when everything is a module
window['e360'] = app;

import './app.config';
import './error-handler.service';
import './main';

import './components/activity-log';
import './components/brand';
import './components/campaign';
import './components/changelog';
import './components/dashboard';
import './components/email';
import './components/event';
import './components/experience';
import './components/guest-type';
import './components/importer';
import './components/org';
import './components/report';
import './components/search';
import './components/survey';
import './components/user';
import './components/user-admin';
import './shared';
